import { useRef, useState } from 'react'
import { storage, db } from './firebase'
import CheckboxListItem from './CheckboxListItem'
import PhotoItem from './PhotoItem'
import { uuid, makeThumbnailPath } from './common'
import Modal from 'react-modal'
import CloseIcon from '@mui/icons-material/Close'
import DeleteIcon from '@mui/icons-material/Delete'
import CircularProgress from '@mui/material/CircularProgress'

import Resizer from 'react-image-file-resizer'

import ConfirmDialog from './ConfirmDialog'

import { connect } from 'react-redux'
import { setForm } from './redux/reducers'

import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import MandatoryField from './MandatoryField'

const canSubmit = (data) => {
  // console.log('Checking can submit', data)
  let result =
    !!data.experiencias && data.experiencias.trim() !== ''
  // const d = data.idiomas
  // let disp = d['português'] || d['inglês'] || d['espanhol'] || d['francês'] || d['alemão'] || d['russo'] || d['mandarim']
  let values = Object.values(data.idiomas)
  let disp = false
  for (let i = 0; i < values.length; i++) {
    if (values[i] === true) {
      disp = true
      break
    }
  }

  result = result && disp && !!data.pics && data.pics.length > 0

  return result
}


const FormPage3 = (props) => {
  // const [pictures, setPictures] = useState([])
  // const [data, setData] = useState(props.formData)
  const [modal, setModal] = useState('none')
  const [showConfirm, setShowConfirm] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)

  const [valid, setValid] = useState(false)

  const [uploading, setUploading] = useState(false)
  const [progress, setProgress] = useState(0)

  let data = props.formData
  // const [image, setImage] = useState(null)
  // const [images, setImages] = useState([])
  // const [fileName, setFileName] = useState('')
  // console.log('Form page 2 here', props)

  // db.ref(`${data.raw}/pics`).on(('value'), (snapshot) => {console.log('SNAP', snapshot)})

  const deletePhoto = urlOfPicture => {
    // console.log(props.formData.pics)
    console.log('deletePHOTO HERE!', urlOfPicture)

    let pic = props.formData.pics.filter((p) => p.image === urlOfPicture)[0]
    console.log('PIC TO DELETE IS', pic)

    let pics = props.formData.pics.filter((p) => p.image !== urlOfPicture)
    // console.log('Filtered pics is', pics)
    // const thumbURL = makeThumbnailPath(url)

    const fileRef = storage.refFromURL(pic.image)
    let thumbRef = storage.refFromURL(pic.thumb)
    // const thirdRef = storage.refFromURL(thumbURL) 

    // console.log(thumbURL)

    console.log(fileRef)
    console.log(thumbRef)
    // console.log(thirdRef)

    fileRef.delete().then(() => {
      // thumbRef.delete().then(() => {
      thumbRef.delete()
      console.log('File deleted!')
      // let data = {
      //   ...props.formData,
      //   pics
      // }
      props.setForm({ pics })
      console.log('updated redux store')
      db.collection('people').doc(data.raw).set({
        ...data, pics
      })
      // })
      console.log('updated db doc')

      setShowConfirm(false)
      setModal('none')
    }).catch((err) => {
      console.log('ERROR DELETING', err)
      alert('Não foi possível excluir o arquivo.')
      setConfirmLoading(false)
    })
  }

  const handleFileChange = async (e) => {
    console.log('IMAGE is', e.target.files)
    if (!e.target || !e.target.files || e.target.files.length === 0) { return }
    // const image = e.target.files[0]
    // if (!image) { return }
    // setFileName(image.name)
    // setImage(image)
    // const data = props.formData
    const files = e.target.files
    for (let i = 0; i < files.length; i++) {
      const f = files[i]

      //Create thumbnail here

      const fileExt = f.name.split('.').pop()
      const fileUUID = uuid()
      const fullPath = `images/${data.raw}/${fileUUID}.${fileExt}`
      // const thumbPath = `images/${data.raw}/${fileUUID}.-thumb.jpg`
      const thumbPath = makeThumbnailPath(fullPath)
      const fileRef = storage.ref(fullPath)
      const thumbRef = storage.ref(thumbPath)

      let pics = props.formData.pics || []
      // let thumbs = props.formData.thumbs || []

      setProgress(0)
      setUploading(true)

      let uploadTask = fileRef.put(f)
      uploadTask.on('state_changed', (snapshot) => {
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        setProgress(progress)
        // console.log('Upload is ' + progress + '% done');
        // console.log(snapshot.state)
      }, (error) => {
        console.log(error)
      }, () => {
        return (uploadTask.snapshot.ref.getDownloadURL())
          .then((downloadURL) => {
            console.log('URL is', downloadURL)

            Resizer.imageFileResizer(
              f,
              200,
              200,
              'JPEG',
              80,
              0,
              (uri) => {
                console.log('Image URI', uri)
                let thumbTask = thumbRef.put(uri)

                thumbTask.on('state_changed',
                  (snapShot) => {
                    //takes a snap shot of the process as it is happening
                    // console.log(snapShot)
                  }, (err) => {
                    //catches the errors
                    console.log(err)
                  }, () => {
                    // gets the functions from storage refences the image storage in firebase by the children
                    // gets the download url then sets the image from firebase as the value for the imgUrl key:
                    thumbTask.snapshot.ref.getDownloadURL()
                      .then(thumbURL => {
                        console.log('Thumbnail url is', thumbURL)
                        //  setImageAsUrl(prevObject => ({...prevObject, imgUrl: fireBaseUrl}))
                        // thumbs.splice(0 ,0, thumbURL)
                        // pics.push(downloadURL)
                        // pics.splice(0, 0, downloadURL)
                        pics.splice(0, 0, { image: downloadURL, thumb: thumbURL, createdAt: new Date().valueOf() })
                        // const newData = {...data, pics}
                        // setData({...data, pics})
                        props.setForm({ ...data, pics })
                        db.collection('people').doc(data.raw).set({
                          ...data, pics,
                        })
                        setUploading(false)

                      })
                  })





              },
              'file',
              100,
              100,
            )

            // setUploading(false)
            // // pics.push(downloadURL)
            // pics.splice(0, 0, downloadURL)
            // // const newData = {...data, pics}
            // // setData({...data, pics})
            // props.setForm({...data, pics, thumbs})
            // db.collection('people').doc(data.raw).set({
            //   ...data, pics, thumbs,
            // })

            return downloadURL
          })
      }
      )

      /************************** */

      // WORKING CODE HERE, NO PROGRESS

      // fileRef.put(f)
      //   .then((snapshot) => { return snapshot.ref.getDownloadURL() })
      //   .then((downloadURL) => {
      //     // console.log('sent file and got link', downloadURL)
      //     // let pics = data.pics || []
      //     console.log('pics is now', pics)
      //     pics.push(downloadURL)
      //     setData({...data, pics})
      //     db.collection('people').doc(data.raw).set({
      //       ...data, pics
      //     })

      //     return downloadURL
      //   })
      //   .catch((error) =>
      //   console.log('Failed!', error))


      /***************** */


      // .on(('state_changed', (sn) => console.log(sn)))
      // // const uploadTask = storage.ref(`images/${data.raw}/${fileUUID}.${fileExt}`).put(f)
      // const uploadTask = storage.ref(`images/${data.raw}/`).put(f)

      // uploadTask.on('state_changed', (sn) => {
      //   const progress = Math.round((sn.bytesTransferred / sn.totalBytes) * 100)
      //   console.log(progress)
      // })
      // uploadTask.on('state_changed',
      // (snapshot) => {
      //   const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
      //   console.log(progress)
      //   if (progress === 100) {
      //     fileRef.getDownloadURL()
      //     .then((downloadURL) => {
      //       console.log(downloadURL)
      //     })
      //   }
      // },
      // (error) => {
      //   console.log(error)
      // })
    }
  }

  const inputFile = useRef(null)
  // console.log('render page 3, photos is', pictures)

  // storage.onSnapshot((s) => {console.log('SNAPSHOT', s)})
  // storage.onUpdate((s) => {console.log('UPDATE', s)})
  // storage.onChange((s) => {console.log('CHANGE', s)})

  // db.collection('people').doc(`${data.raw}`).onSnapshot((snapshot) => {

  //   return

  //   const newData = snapshot.data()
  //   // console.log('--- SNAPSHOT ---', newData)
  //   // console.log('curData', data)
  //   // const pics = snapshot.data().pics || []
  //   // console.log('equal', (pics === pictures))
  //   // console.log('pics', newData.pics)
  //   // console.log('pictures', pictures)
  //   // const sameObject = JSON.stringify(newData) === JSON.stringify(data)
  //   const samePics = JSON.stringify(newData.pics) === JSON.stringify(pictures)
  //   console.log('pics equal?', samePics)
  //   // console.log('data is', data)
  //   if (!samePics) {
  //     console.log('Will set pictures', newData.pics)
  //     setPictures(newData.pics)
  //     // startSetForm
  //   }
  //   //   console.log('pics will be', pics)
  //   //   setPictures(pics)
  //   // }

  // })

  setTimeout(() => setValid(canSubmit(data), 1))

  return (
    <>
      <Modal
        isOpen={modal !== 'none'}
        closeTimeoutMS={300}
        onRequestClose={() => setModal('none')}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}

        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
          },
          content: {
            // position: 'absolute',
            // top: '40px',
            // left: '140px',
            // right: '140px',
            // bottom: '40px',
            // border: '1px solid #bd0404',
            border: 'none',
            backgroundColor: '#000',
            // backgroundColor: 'blue',
            borderRadius: '8px',
            // display: 'flex',
            // flexDirection: 'column',
            // outline: 'none',
            padding: 0,
            margin: 0,
            // padding: '20px',
            // elevation: 8,
            boxShadow: '3px 3px rgba(0,0,0,0.5)',
          }
        }}
      >
        <div className={'modal-image-container'}
        // style={{
        //   height: '90%',
        //   width: '100%',
        //   display: 'flex',
        //   flexDirection: 'column',
        //   alignItems: 'center',
        //   justifyContent: 'flex-start',
        // }}
        >

          <img className={'modal-image'} src={modal} alt={'Foto'}
          // onLoad={() => setModalLoaded(true)} onLoadStart={() => setModalLoaded(false)}
          // style={{visibility: modalLoaded ? 'visible' : 'hidden'}}
          // width={'auto'} height={'auto'}
          // style={{flex: 1, maxHeight: '100%', width: 'auto', height: 'auto', maxWidth: '100%'}}
          />
        </div>
        <div className={'modal-footer'}>
          <button className="image-button" onClick={() => setModal('none')}><CloseIcon /></button>
          <button className="image-button" onClick={() => {
            setConfirmLoading(false)
            setShowConfirm(true)
          }}>
            <DeleteIcon />
          </button>
        </div>
      </Modal>


      <ConfirmDialog
        title={'Excluir foto?'}
        message={'Deseja excluir esta foto?\n\nEssa ação não pode ser desfeita.'}
        cancelTitle={'Não'}
        actionTitle={'Excluir'}
        actionLoading={confirmLoading}
        isOpen={showConfirm}
        onClose={() => setShowConfirm(false)}
        onCancel={() => setShowConfirm(false)}
        onAction={() => {
          console.log('DELETE!', modal)
          setConfirmLoading(true)
          deletePhoto(modal)

        }}
      />



      <form className="form"
        style={{
          alignItems: 'center'
        }}>

        <div className="form-header">Perfil</div>
        <div className="form-field-group">
          <input
            type="file"
            id="file"
            ref={inputFile}
            accept={'image/*'}
            multiple
            onChange={(e) => handleFileChange(e)}
            style={{ display: 'none' }}
          />
          <MandatoryField title='Fotos:' />
          <label htmlFor="fileInput">
            <div className="form-images-list">

              <div
                className="photo-item-container"
                style={{ cursor: 'pointer', backgroundColor: '#EEE' }}
                onClick={() => inputFile.current.click()}
              // onClick={() => this.fileInput.click()}  
              >
                <div><AddCircleOutlineIcon style={{ fontSize: '22pt', minWidth: '90px' }} /></div>
                <div style={{ fontSize: '11pt' }}>Adicionar</div>
              </div>

              {uploading &&
                // {true &&
                <div
                  className="photo-item-container"
                  style={{ boxShadow: 'none', backgroundColor: '#EEE', minWidth: '90px' }}
                >
                  Enviando...<br />
                  <CircularProgress variant="determinate" style={{ color: '#bd0404', transform: 'scale(0.6)', }} value={Math.max(progress, 5)} />
                </div>
              }



              {/* {data.pics?.map((path) => ( */}

              {props.formData.pics?.map(({ image, thumb }) => (

                // {pictures?.map((path) => (
                <PhotoItem path={thumb} key={thumb} onClick={() => setModal(image)} />
              ))}


            </div>
          </label>
        </div>

        <div className="form-field-group">
          Link do seu perfil no Facebook:
          <input type="text" name="facebook" className="form-text"
            value={data.facebook ? data.facebook : ''}
            onChange={((e) => {
              // let formData = {
              //   ...data,
              //   facebook: e.target.value
              // }
              // this.setState({formData})
              props.setForm({ facebook: e.target.value })
            })}
          />
        </div>


        <div className="form-field-group">
          Link do seu perfil no Instagram:
          <input type="text" name="instagram" className="form-text"
            value={data.instagram ? data.instagram : ''}
            onChange={((e) => {
              // let formData = {
              //   ...data,
              //   instagram: e.target.value
              // }
              // this.setState({formData})
              props.setForm({ instagram: e.target.value })
            })}
          />
        </div>

        <div className="form-field-group">
          <MandatoryField title='Idiomas em que é fluente:' />
          <div className="form-list-box">
            <CheckboxListItem
              title="Português"
              checked={!!data.idiomas && data.idiomas['português']}
              onPress={() => {
                let idiomas = { ...data.idiomas }
                idiomas['português'] = !idiomas['português']
                let formData = {
                  ...data,
                  idiomas
                }
                props.setForm(formData)
                setValid(canSubmit({ ...data, idiomas }))
              }}
              noBorder={false}
            />
            <CheckboxListItem
              title="Inglês"
              checked={!!data.idiomas && data.idiomas['inglês']}
              onPress={() => {
                let idiomas = { ...data.idiomas }
                idiomas['inglês'] = !idiomas['inglês']
                let formData = {
                  ...data,
                  idiomas
                }
                props.setForm(formData)
                setValid(canSubmit({ ...data, idiomas }))
              }}
              noBorder={false}
            />
            <CheckboxListItem
              title="Espanhol"
              checked={!!data.idiomas && data.idiomas['espanhol']}
              onPress={() => {
                let idiomas = { ...data.idiomas }
                idiomas['espanhol'] = !idiomas['espanhol']
                // let formData = {
                //   ...data,
                //   idiomas
                // }
                props.setForm({ idiomas })
                setValid(canSubmit({ ...data, idiomas }))
              }}
              noBorder={false}
            />
            <CheckboxListItem
              title="Francês"
              checked={!!data.idiomas && data.idiomas['francês']}
              onPress={() => {
                let idiomas = { ...data.idiomas }
                idiomas['francês'] = !idiomas['francês']
                // let formData = {
                //   ...data,
                //   idiomas
                // }
                props.setForm({ idiomas })
                setValid(canSubmit({ ...data, idiomas }))
              }}
              noBorder={false}
            />
            <CheckboxListItem
              title="Alemão"
              checked={!!data.idiomas && data.idiomas['alemão']}
              onPress={() => {
                let idiomas = { ...data.idiomas }
                idiomas['alemão'] = !idiomas['alemão']
                // let formData = {
                //   ...data,
                //   idiomas
                // }
                props.setForm({ idiomas })
                setValid(canSubmit({ ...data, idiomas }))
              }}
              noBorder={false}
            />
            <CheckboxListItem
              title="Mandarim"
              checked={!!data.idiomas && data.idiomas['mandarim']}
              onPress={() => {
                let idiomas = { ...data.idiomas }
                idiomas['mandarim'] = !idiomas['mandarim']
                // let formData = {
                //   ...data,
                //   idiomas
                // }
                props.setForm({ idiomas })
                setValid(canSubmit({ ...data, idiomas }))
              }}
              noBorder={false}
            />
            <CheckboxListItem
              title="Russo"
              checked={!!data.idiomas && data.idiomas['russo']}
              onPress={() => {
                let idiomas = { ...data.idiomas }
                idiomas['russo'] = !idiomas['russo']
                // let formData = {
                //   ...data,
                //   idiomas
                // }
                props.setForm({ idiomas })
                setValid(canSubmit({ ...data, idiomas }))

              }}
              noBorder={false}
            />
          </div>
          <div className="form-sub-field">
            Outros:
            <input type="text" name="idiomasOutros" className="form-text"
              // style={{marginLeft: '8px'}}
              value={data.idiomasOutros ? data.idiomasOutros : ''}
              onChange={((e) => {
                // let formData = {
                //   ...data,
                //   idiomasOutros: e.target.value
                // }
                // this.setState({formData})
                props.setForm({ idiomasOutros: e.target.value })

              })}
            />
          </div>
        </div>

        <div className="form-field-group">
          <MandatoryField title='Experiências anteriores (recepção, blitz, degustação etc):' />
          <textarea type="text" name="experiencias" className="form-text"
            rows={5}

            value={data.experiencias ? data.experiencias : ''}
            onChange={((e) => {
              // let formData = {
              //   ...data,
              //   experiencias: e.target.value
              // }
              // this.setState({formData})
              props.setForm({ experiencias: e.target.value })
              setValid(canSubmit({ ...data, experiencias: e.target.value }))

            })}
          />
        </div>

        <div className="form-send-row">
          <button
            // onClick={() => history.goBack()}
            // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
            className="login-button"
            onClick={() => props.onPrev()}
          >{`${'< Voltar'}`}
          </button>
          <button
            // disabled={!this.state.cpf || !this.state.isCPFValid || this.state.loading}
            disabled={!valid}
            className="login-button"
            onClick={() => props.onNext()}
          >{`${'Continuar >'}`}</button>
        </div>
        {/* {
  !!this.state.error &&
  <div className="login-error">{this.state.error}</div>
  } */}
      </form>
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
  // startLogin: (user, password) => dispatch(startLogin(user, password)),
  setForm: (data) => dispatch(setForm(data)),
  // getLots: () => dispatch(getLots()),
})

const mapStateToProps = (state) => ({
  formData: state.form,
})

export default connect(mapStateToProps, mapDispatchToProps)(FormPage3)
// export default FormPage3
